import {
    CompanyLogo,
    HeaderNavMenu,
    HeaderUserMenu,
    ScrollToTop,
} from '@/components/export';

export const Header = (props: {
    onRefresh?: () => void,
}) => {
    return <>
        <ScrollToTop/>
        <div className="header-wrapper">
            <div className="header-main">
                <div className="header-main__container">
                    <div className="header-main__nav">
                        <CompanyLogo/>
                        <HeaderNavMenu/>
                    </div>

                    <HeaderUserMenu
                        onRefresh={props.onRefresh}
                    />
                </div>
            </div>
        </div>
    </>;
};
